import { BaseRouter } from 'next/dist/shared/lib/router/router'

export const getLoginCallbackUrl = (router: BaseRouter): string => {
  const { callbackUrl } = router.query

  if (typeof callbackUrl === 'string' && callbackUrl) {
    try {
      const parsedUrl = new URL(callbackUrl)
      const basePath = process.env.NEXT_PUBLIC_BASE_PATH || ''

      return parsedUrl.origin.startsWith(basePath) ? callbackUrl : '/'
    } catch {
      // If new URL(callbackUrl) fails, it means the callbackUrl is not absolute
      return callbackUrl
    }
  }

  return '/'
}
